import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectUsers } from 'store/chat/services/getProjectUsers.service';
import fetchFile from 'utils/fetchFile';

export const getProjectUsersThunk = createAsyncThunk(
  'chat/getProjectUsers',
  async ({ projectId }, { getState }) => {
    const state = getState();
    const { allUsers } = state.chatSlice;

    const response = await getProjectUsers(projectId);

    const users = {};
    const missingUserIds = [];

    // First, check if users exist in allUsers
    for (const user of response.users) {
      if (allUsers[user.id]) {
        // User already exists in allUsers, use it
        users[user.id] = allUsers[user.id];
      } else {
        // User not found in allUsers, need to fetch image
        missingUserIds.push(user);
      }
    }

    // Only fetch images for users not in allUsers
    for (const user of missingUserIds) {
      let imageSrc = null;
      if (user.image) {
        imageSrc = await fetchFile(`thumbs/${user.image.key}`);
      }
      users[user.id] = {
        ...user,
        image: imageSrc,
      };
    }

    return users;
  }
);
